import Cookies from 'js-cookie'
import VueRouter from 'vue-router'
import logic from '@/common/logic'
import { judgeVersionRemind } from '@/util/checkVersion'

const MainLayout = () => import('./pages/MainLayout.vue')
const FramePage = () => import('./pages/FramePage.vue')


const HelperShareDetail = () => import('./pages/shareHelperList/HelperShareDetail.vue')
const shareHelperList = () => import('./pages/shareHelperList/shareHelperList.vue')


const Chat = () => import('./pages/chat/index.vue')
const Login = () => import('./pages/login/Login.vue')
const RegisterForLogin = () => import('./pages/login/RegisterForLogin.vue')
const CreateAccountNew = () => import('./pages/login/CreateAccountNew.vue')
const Dashboard = () => import('./pages/dashboard/Dashboard.vue')
const MileageRecordList = () => import('./pages/report/MileageRecordList.vue')
const DriverStops = () => import('./pages/report/DriverStops.vue')
const EmployerAddress = () => import('./pages/report/EmployerAddress.vue')
const DashboardForSupplier = () => import('./pages/dashboard/DashboardForSupplier.vue')
const DashboardForInsurance = () => import('./pages/dashboard/DashboardForInsurance.vue')
const DashboardForLending = () => import('./pages/dashboard/DashboardForLending.vue')
const DashboardForTraining = () => import('./pages/dashboard/DashboardForTraining.vue')
const AgencyList = () => import('./pages/AgencyList.vue')
const AdminAgencyDetail = () => import('./pages/adminAgency/AgencyDetail.vue')
const SupplierList = () => import('./pages/SupplierList.vue')
const EmployerList = () => import('./pages/employer/EmployerList.vue')
const EmployerDetail = () => import('./pages/employer/EmployerDetail.vue')
const HelperList = () => import('./pages/helper/HelperList.vue')
const HelperDetail = () => import('./pages/helper/HelperDetail.vue')
const PreviewBioData = () => import('./pages/helper/bioData/PreviewBioData.vue')
const InterviewList = () => import('./pages/interview/InterviewList.vue')
const Dormitory = () => import('./pages/dormitory/DormitoryList.vue')
const FeedList = () => import('./pages/feed/FeedList.vue')
const FeedEdit = () => import('./pages/feed/FeedEdit.vue')
const ArticleList = () => import('./pages/article/ArticleList.vue')
const ArticleEdit = () => import('./pages/article/ArticleEdit.vue')
const ArticleDhList = () => import('./pages/article/ArticleDhList.vue')
const ArticleDhEdit = () => import('./pages/article/ArticleDhEdit.vue')
const NotificationList = () => import('./pages/notification/NotificationList.vue')
const SettingIndex = () => import('./pages/setting/SettingIndex.vue')
const TemplateDetail = () => import('./pages/setting/TemplateDetail.vue')
const BioTemplateDetail = () => import('./pages/setting/BioTemplateDetail.vue')
const NoCompanyIndex = () => import('./pages/setting/NoCompanyIndex.vue')
const ContractList = () => import('./pages/contract/ContractList.vue')
const ContractAfterSales = () => import('./pages/contract/ContractAfterSales.vue')
const ContractAfterSalesDetail = () => import('./pages/contract/ContractAfterSalesDetail.vue')
const ContractBioData = () => import('./pages/contract/ContractBioData.vue')
const ContractDetail = () => import('./pages/contract/ContractDetail.vue')
const ContractEditCustomTemplate = () => import('./pages/contract/ContractEditCustomTemplate.vue')
const ContractPreviewPdf = () => import('./pages/contract/ContractPreviewPdf.vue')
const ContractCollectJobOffer = () => import('./pages/contract/ContractCollectJobOffer.vue')
const ContractCollectEmployerInfo = () => import('./pages/contract/ContractCollectEmployerInfo.vue')
const HKContractCollectEmployerInfo = () => import('./pages/contract/HKContractCollectEmployerInfo.vue')
const HKContractCollectJobOffer = () => import('./pages/contract/HKContractCollectJobOffer.vue')
const HKSalesContractCollectEmployerInfo = () => import('./pages/contract/HKSalesContractCollectEmployerInfo.vue')
const HKSalesContractCollectJobOffer = () => import('./pages/contract/HKSalesContractCollectJobOffer.vue')
const ContractCollectSponsorJointInfo = () => import('./pages/contract/ContractCollectSponsorJointInfo.vue')
const ContractCollectSpouseInfo = () => import('./pages/contract/ContractCollectSpouseInfo.vue')
const InsurancePreviewPdf = () => import('./pages/insurance/InsurancePreviewPdf.vue')
const ReceiptPDF = () => import('./pages/contract/ReceiptPDF.vue')
const ContractSignPdf = () => import('./pages/contract/ContractSignPdf.vue')
const HelperSignature = () => import('./pages/helper/HelperSignature.vue')
const ContractShareHelperTraining = () => import('./pages/contract/ContractShareHelperTraining.vue')
const InsuranceSignPdf = () => import('./pages/insurance/InsuranceSignPdf.vue')
const SupplierLink = () => import('./pages/supplierContract/SupplierLink.vue')
const ReleaseLetterList = () => import('./pages/release/ReleaseLetterList.vue')
const ReleasePdf = () => import('./pages/release/ReleasePdf.vue')
const Homepage = () => import('./pages/landing/homepage.vue')
const MaidShare = () => import('./pages/landing/MaidShare.vue')
const ContractShare = () => import('./pages/landing/ContractShare.vue')
const pdfPrint = () => import('./pages/landing/pdfPrint.vue')
const AboutUs = () => import('./pages/landing/aboutUs.vue')
const EASoftware = () => import('./pages/landing/EASoftware.vue')
const MaidIsland = () => import('./pages/landing/MaidIsland.vue')
const EASYInsurance = () => import('./pages/landing/EASYInsurance.vue')
const EASYTransport = () => import('./pages/landing/EASYTransport.vue')
const SupplyOn = () => import('./pages/landing/SupplyOn.vue')
const TermsAndCondition = () => import('./components/TermsAndCondition.vue')
const PrivacyPolicy = () => import('./components/PrivacyPolicy.vue')
const AgencySupplierList = () => import('./pages/agencySupplierList/AgencySupplierList.vue')
const SupplierAgencyList = () => import('./pages/supplierAgency/SupplierAgencyList.vue')
const SupplierAgencyDetail = () => import('./pages/supplierAgency/SupplierAgencyDetail.vue')
const AgencySideAgencyList = () => import('./pages/agencySideAgency/AgencySideAgencyList.vue')
const AgencySideAgencyDetail = () => import('./pages/agencySideAgency/AgencySideAgencyDetail.vue')
const SupplierContractList = () => import('./pages/supplierContract/SupplierContractList.vue')
const DelayList = () => import('./pages/supplierContract/DelayList.vue')
const SupplierContractDetail = () => import('./pages/supplierContract/SupplierContractDetail.vue')
const transportList = () => import('./pages/transportList/TransportList.vue')
const AddTransport = () => import('./pages/transportList/AddTransport.vue')
const TransportDetail = () => import('./pages/transportList/TransportDetail.vue')
const PJAgencyList = () => import('./pages/pjAgency/PJAgencyList.vue')
const PJAgencyDetail = () => import('./pages/pjAgency/PJAgencyDetail.vue')
const PJOrderList = () => import('./pages/pjOrder/PJOrderList.vue')
const InsuranceOrderList = () => import('./pages/insurance/insuranceOrderList.vue')
const InsuranceOrderCreate = () => import('./pages/insurance/insuranceOrderCreate.vue')
const InsuranceOrderDetail = () => import('./pages/insurance/insuranceOrderDetail.vue')
const InsuranceAgencyList = () => import('./pages/insurance/insuranceAgencyList.vue')
const insuranceAgencyCreate = () => import('./pages/insurance/insuranceAgencyCreate.vue')
const insuranceAgencyDetail = () => import('./pages/insurance/insuranceDetails.vue')
const insuranceSetting = () => import('./pages/insurance/insuranceSetting.vue')
const PJScheduleList = () => import('./pages/pjSchedule/PJScheduleList.vue')
const CheckInOutList = () => import('./pages/dormitory/CheckInOutList.vue')
const DailyReportList = () => import('./pages/dormitory/DailyReportList.vue')
const BedManagementList = () => import('./pages/dormitory/BedManagementList.vue')
const PJOrderDetail = () => import('./pages/pjOrder/PJOrderDetail.vue')
const PJSetting = () => import('./pages/pjOrder/PJSetting.vue')
const Payments = () => import('./pages/finance/Payments.vue')
const ExpenseClaimTemplateList = () => import('./pages/finance/ExpenseClaim/ExpenseClaimTemplateList.vue')
const ExpenseClaimTemplateEdit = () => import('./pages/finance/ExpenseClaim/ExpenseClaimTemplateEdit.vue')
const ExpenseClaimTemplateDetail = () => import('./pages/finance/ExpenseClaim/ExpenseClaimTemplateDetail.vue')
const Payable = () => import('./pages/finance/AP/Payable.vue')
const Receivable = () => import('./pages/finance/AR/Receivable.vue')
const ReceivableDetail = () => import('./pages/finance/AR/ReceivableDetail.vue')
const ReceivedDetail = () => import('./pages/finance/AR/ReceivedDetail.vue')
const InvoiceDetail = () => import('./pages/finance/AR/InvoiceDetail.vue')
const PayableDetail = () => import('./pages/finance/AP/PayableDetail.vue')
const PaymentDetail = () => import('./pages/finance/AP/PaymentDetail.vue')
const ExpenseClaimList = () => import('./pages/finance/ExpenseClaim/ExpenseClaimList.vue')
const ExpenseClaimDetail = () => import('./pages/finance/ExpenseClaim/ExpenseClaimDetail.vue')
const Journals = () => import('./pages/finance/Journals.vue')
const Report = () => import('./pages/finance/Report.vue')
const BankStatements = () => import('./pages/finance/BankStatements/index.vue')
const CreateVoucher = () => import('./pages/finance/CreateVocher.vue')
const VoucherDetail = () => import('./pages/finance/VoucherDetail.vue')
const PrivateCreateAccount = () => import('./pages/private/CreateAccount.vue')
const DriverScheduleList = () => import('./pages/driverScheduleList/DriverScheduleList.vue')
const PjSupplierList = () => import('./pages/pjSuppplier/PjSupplierList.vue')
const NotFound = () => import('./components/NotFound.vue')
const PrintPrew = () => import('./pages/print/PrintPrew.vue')
const InvoiceTemp = () => import('./pages/print/InvoiceTemp.vue')
const EnquiryList = () => import('./pages/enquiry/enquiryList.vue')
const EnquiryDetail = () => import('./pages/enquiry/enquiryDetail.vue')
const SatisfactionSurvey = () => import('./pages/SatisfactionSurvey.vue')

const LoanOrderList = () => import('./pages/loanOrder/LoanOrderList.vue')
const LoanOrderDetail = () => import('./pages/loanOrder/LoanOrderDetail.vue')
const RepaymentPlanList = () => import('./pages/RepaymentPlan/RepaymentPlanList.vue')
const PHEmbassy = () => import('./pages/embassy/PHEmbassy.vue')
const TrainingOrderList = () => import('./pages/trainingOrder/TrainingOrderList.vue')
const TrainingOrderDetail = () => import('./pages/trainingOrder/TrainingOrderDetail.vue')
const ContractCertificateOfSignature = () => import('./pages/contract/ContractCertificateOfSignature.vue')
const ShareVideo = () => import('./pages/shareHelperList/ShareVideo.vue')

const routes: any[] = [{
    path: '/',
    component: FramePage,
    children: [{
        path: '',
        component: Homepage,
        name: 'Homepage',
    }, {
        path: 'shareVideo',
        component: ShareVideo,
        name: 'ShareVideo',
    }, {
        path: 'shareHelper/list',
        component: shareHelperList,
        name: 'shareHelperListNotLogged',
    }, {
        path: 'HelperShareDetail/:id',
        component: HelperShareDetail,
        name: 'HelperShareDetailNotLogged',
        meta: {
            externalRecruiter: true,
        },
    }, {
        path: 'maid/:businessName/:code',
        component: MaidShare,
        name: 'MaidShare',
    }, {
        path: 'maid/PH/:businessName/:code',
        component: MaidShare,
        name: 'PHMaidShare',
    }, {
        path: 'contractShare/:businessName/:code',
        component: ContractShare,
        name: 'ContractShare',
    }, {
        path: 'pdfPrint',
        component: pdfPrint,
        name: 'pdfPrint',
    }, {
        path: 'TermsAndCondition',
        component: TermsAndCondition,
        name: 'TermsAndCondition',
    }, {
        path: 'PrivacyPolicy',
        component: PrivacyPolicy,
        name: 'PrivacyPolicy',
    }, {
        path: 'aboutUs',
        component: AboutUs,
        name: 'AboutUs',
    }, {
        path: 'EASoftware',
        component: EASoftware,
        name: 'EASoftware',
    }, {
        path: 'MaidIsland',
        component: MaidIsland,
        name: 'MaidIsland',
    }, {
        path: 'EASYTransport',
        component: EASYTransport,
        name: 'EASYTransport',
    }, {
        path: 'EASYInsurance',
        component: EASYInsurance,
        name: 'EASYInsurance',
    }, {
        path: 'SupplyOn',
        component: SupplyOn,
        name: 'SupplyOn',
    }, {
        path: 'printPrew',
        component: PrintPrew,
        name: 'PrintPrew',
    }, {
        path: 'satisfactionSurvey',
        component: SatisfactionSurvey,
        name: 'SatisfactionSurvey',
    }, {
        path: 'certificateOfSignature/:refNo/:contractSignatureId',
        component: ContractCertificateOfSignature,
        name: 'ContractCertificateOfSignature',
    }, {
        path: 'easy',
        component: FramePage,
        children: [{
            path: '',
            component: MainLayout,
            children: [{
                path: 'dashboard',
                component: Dashboard,
                name: 'Dashboard',
            }, {
                path: 'mileageRecordList',
                component: MileageRecordList,
                name: 'MileageRecordList',
                meta: {
                    firstMenu: '/easy/report',
                    subMenu: '/easy/report/mileageRecord',
                },
            }, {
                path: 'report/driverStops',
                component: DriverStops,
                name: 'DriverStops',
            }, {
                path: 'report/employerAddress',
                component: EmployerAddress,
                name: 'EmployerAddress',
            }, {
                path: 'dashboard/supplier',
                component: DashboardForSupplier,
                name: 'DashboardForSupplier',
            }, {
                path: 'dashboard/insurance',
                component: DashboardForInsurance,
                name: 'DashboardForInsurance',
            }, {
                path: 'dashboard/lending',
                component: DashboardForLending,
                name: 'DashboardForLending',
            }, {
                path: 'dashboard/training',
                component: DashboardForTraining,
                name: 'DashboardForTraining',
            }, {
                path: 'private/createAccount',
                component: PrivateCreateAccount,
                name: 'PrivateCreateAccount',
            }, {
                path: 'shareHelper/list',
                component: shareHelperList,
                name: 'shareHelperList',
            }, {
                path: 'HelperShareDetail/:id',
                component: HelperShareDetail,
                name: 'HelperShareDetail',
                meta: {
                    externalRecruiter: true,
                },
            }, {
                path: 'agency',
                component: AgencyList,
                name: 'AgencyList',
            }, {
                path: 'admin/agencyDetail/:id',
                component: AdminAgencyDetail,
                name: 'AdminAgencyDetail',
            }, {
                path: 'supplier',
                component: SupplierList,
                name: 'SupplierList',
            }, {
                path: 'employer/list',
                component: EmployerList,
                name: 'EmployerList',
                meta: {
                    position() {
                        return 'Employer List'
                    },
                    title: 'Employer List',
                },
            }, {
                path: 'employer/detail/:tab/:id',
                component: EmployerDetail,
                name: 'EmployerDetail',
                meta: {
                    position() {
                        let map = {
                            jobs: 'Jobs',
                            matching: 'Matching List',
                            EANote: 'EA Note',
                            contact: 'Contact Information',
                            settings: 'Account Settings',
                        }
                        return map[this.params.tab]
                    },
                },
            }, {
                path: 'helper/list',
                component: HelperList,
                name: 'HelperList',
                meta: {
                    position() {
                        return 'Helper List'
                    },
                    title: 'Helper List',
                    externalRecruiter: true,
                },
            }, {
                path: 'helper/detail/:tab/:id',
                component: HelperDetail,
                name: 'HelperDetail',
                meta: {
                    position() {
                        let map = {
                            profile: 'Profile',
                            history: 'Employment History',
                            identity: 'Identity',
                            jobStatus: 'Job Status',
                            EAInterview: 'EA Interview',
                            EANote: 'EA Note',
                            matching: 'Matching List',
                            refer: 'Refer Friends',
                            supplierRefer: 'Refer Friends',
                            settings: 'Account Settings',
                        }
                        return map[this.params.tab]
                    },
                    externalRecruiter: true,
                },
            }, {
                path: 'enquiry/list',
                component: EnquiryList,
                name: 'EnquiryList',
                meta: {
                    title: 'Enquiry List',
                },
            }, {
                path: 'enquiry/detail/:id',
                component: EnquiryDetail,
                name: 'EnquiryDetail',
                meta: {
                    title: 'Enquiry Detail',
                },
            }, {
                path: 'interview/list',
                component: InterviewList,
                name: 'InterviewList',
                meta: {
                    title: 'Interview List',
                },
            }, {
                path: 'dormitory/list',
                component: Dormitory,
                name: 'Dormitory',
                meta: {
                    title: 'Dormitory List',
                },
            }, {
                path: 'agencySupplier/list',
                component: AgencySupplierList,
                name: 'AgencySupplierList',
                meta: {
                    title: 'Easy',
                },
            }, {
                path: 'transport/list',
                component: transportList,
                name: 'transportList',
                meta: {
                    title: 'Transport List',
                },
            }, {
                path: 'transport/addNew',
                component: AddTransport,
                name: 'AddTransport',
            }, {
                path: 'transport/detail/:id',
                component: TransportDetail,
                name: 'TransportDetail',
            }, {
                path: 'pjAgency/list',
                component: PJAgencyList,
                name: 'pjAgencyList',
            }, {
                path: 'pjAgency/create',
                component: PJAgencyDetail,
                name: 'CreatePJAgency',
            }, {
                path: 'pjAgency/detail/:id',
                component: PJAgencyDetail,
                name: 'pjAgencyDetail',
            }, {
                path: 'pjOrder/list',
                component: PJOrderList,
                name: 'pjOrderList',
            }, {
                path: 'pjSchedule/list',
                component: PJScheduleList,
                name: 'pjScheduleList',
            }, {
                path: 'dormitory/checkInOut',
                component: CheckInOutList,
                name: 'CheckInOutList',
            }, {
                path: 'dormitory/dailyReport',
                component: DailyReportList,
                name: 'DailyReportList',
            }, {
                path: 'dormitory/bedManagement',
                component: BedManagementList,
                name: 'BedManagementList',
            }, {
                path: 'DriverSchedule/list',
                component: DriverScheduleList,
                name: 'DriverScheduleList',
            }, {
                path: 'pjOrder/detail/:id',
                component: PJOrderDetail,
                name: 'PJOrderDetail',
            }, {
                path: 'pjSetting/new/:tab',
                component: PJSetting,
                name: 'PJSetting',
            }, {
                path: 'pjSupplier/list',
                component: PjSupplierList,
                name: 'PjSupplierList',
            }, {
                path: 'agencySideAgency/list',
                component: AgencySideAgencyList,
                name: 'AgencySideAgencyList',
            }, {
                path: 'agencySideAgency/create',
                component: AgencySideAgencyDetail,
                name: 'CreateAgencySideAgency',
            }, {
                path: 'agencySideAgency/detail/:id',
                component: AgencySideAgencyDetail,
                name: 'AgencySideAgencyDetail',
            }, {
                path: 'supplierAgency/list',
                component: SupplierAgencyList,
                name: 'SupplierAgencyList',
                meta: {
                    title: 'Easy',
                },
            }, {
                path: 'supplierAgency/create',
                component: SupplierAgencyDetail,
                name: 'CreateSupplierAgency',
            }, {
                path: 'supplierAgency/detail/:id',
                component: SupplierAgencyDetail,
                name: 'SupplierAgencyDetail',
            }, {
                path: 'supplierContract/list',
                component: SupplierContractList,
                name: 'SupplierContractList',
                meta: {
                    title: 'Contract List',
                },
            }, {
                path: 'supplierContractDetail/:refNo',
                component: SupplierContractDetail,
                name: 'SupplierContractDetail',
                meta: {
                    title: 'Contract Detail',
                    firstMenu: '/easy/supplierContract',
                },
            }, {
                path: 'delay/list',
                component: DelayList,
                name: 'DelayList',
                meta: {
                    title: 'Delay List',
                },
            }, {
                path: 'release/list',
                component: ReleaseLetterList,
                name: 'ReleaseLetterList',
            }, {
                path: 'feed/list',
                component: FeedList,
                name: 'FeedList',
            }, {
                path: 'feed/create',
                component: FeedEdit,
                name: 'FeedCreate',
            }, {
                path: 'feed/edit/:id',
                component: FeedEdit,
                name: 'FeedEdit',
            }, {
                path: 'article/list',
                component: ArticleList,
                name: 'ArticleList',
            }, {
                path: 'article/create',
                component: ArticleEdit,
                name: 'ArticleCreate',
            }, {
                path: 'articleDh/list',
                component: ArticleDhList,
                name: 'ArticleDhList',
            }, {
                path: 'articleDh/create',
                component: ArticleDhEdit,
                name: 'ArticleDhCreate',
            }, {
                path: 'articleDh/edit/:id',
                component: ArticleDhEdit,
                name: 'ArticleDhEdit',
            }, {
                path: 'notification/list',
                component: NotificationList,
                name: 'NotificationList',
            }, {
                path: 'article/edit/:id',
                component: ArticleEdit,
                name: 'ArticleEdit',
            }, {
                path: 'finance/payments',
                component: Payments,
                name: 'Payments',
            }, {
                path: 'finance/PA/list',
                component: Payable,
                name: 'Payable',
            }, {
                path: 'finance/PA/payableDetail/:id',
                component: PayableDetail,
                name: 'PayableDetail',
            }, {
                path: 'finance/PA/paymentDetail/:id',
                component: PaymentDetail,
                name: 'PaymentDetail',
            }, {
                path: 'finance/AR/list',
                component: Receivable,
                name: 'Receivable',
            }, {
                path: 'finance/AR/receivableDetail/:id',
                component: ReceivableDetail,
                name: 'ReceivableDetail',
            }, {
                path: 'finance/AR/receivedDetail/:id',
                component: ReceivedDetail,
                name: 'ReceivedDetail',
            }, {
                path: 'finance/AR/invoiceDetail/:id',
                component: InvoiceDetail,
                name: 'InvoiceDetail',
            }, {
                path: 'finance/journals',
                component: Journals,
                name: 'Journals',
                meta: {
                    firstMenu: '/easy/finance',
                    subMenu: '/easy/finance/journals',
                },
            }, {
                path: 'finance/createVoucher',
                component: CreateVoucher,
                name: 'CreateVoucher',
                meta: {
                    firstMenu: '/easy/finance',
                    subMenu: '/easy/finance/journals',
                },
            }, {
                path: 'finance/voucherDetail/:id',
                component: VoucherDetail,
                name: 'VoucherDetail',
                meta: {
                    firstMenu: '/easy/finance',
                    subMenu: '/easy/finance/journals',
                },
            }, {
                path: 'finance/report',
                component: Report,
                name: 'Report',
                meta: {
                    firstMenu: '/easy/finance',
                    subMenu: '/easy/finance/report',
                },
            }, {
                path: 'finance/bankStatements',
                component: BankStatements,
                name: 'BankStatements',
                meta: {
                    firstMenu: '/easy/finance',
                    subMenu: '/easy/finance/bankStatements',
                },
            }, {
                path: 'finance/expenseClaim/list',
                component: ExpenseClaimList,
                name: 'ExpenseClaimList',
            }, {
                path: 'finance/expenseClaim/create',
                component: ExpenseClaimDetail,
                name: 'ExpenseClaimCreate',
            }, {
                path: 'finance/expenseClaim/detail/:id',
                component: ExpenseClaimDetail,
                name: 'ExpenseClaimDetail',
            }, {
                path: 'finance/expenseClaimTemplate/list',
                component: ExpenseClaimTemplateList,
                name: 'ExpenseClaimTemplateList',
                meta: {
                    firstMenu: '/easy/finance',
                    subMenu: '/easy/finance/setting',
                },
            }, {
                path: 'finance/ExpenseClaimTemplate/edit',
                component: ExpenseClaimTemplateEdit,
                name: 'ExpenseClaimTemplateEdit',
                meta: {
                    firstMenu: '/easy/finance',
                    subMenu: '/easy/finance/setting',
                },
            }, {
                path: 'finance/ExpenseClaimTemplateDetail/:id',
                component: ExpenseClaimTemplateDetail,
                name: 'ExpenseClaimTemplateDetail',
                meta: {
                    firstMenu: '/easy/finance',
                    subMenu: '/easy/finance/setting',
                },
            }, {
                path: 'setting/:tab',
                component: SettingIndex,
                name: 'SettingIndex',
            }, {
                path: 'setting/templates/detail/:id',
                component: TemplateDetail,
                name: 'TemplateDetail',
            }, {
                path: 'setting/bioTemplate/detail/:id',
                component: BioTemplateDetail,
                name: 'BioTemplateDetail',
            }, {
                path: 'noCompanyIndex',
                component: NoCompanyIndex,
                name: 'NoCompanyIndex',
            }, {
                path: 'contract/list',
                component: ContractList,
                name: 'ContractList',
                meta: {
                    title: 'Contract List',
                    firstMenu: '/easy/contract',
                    subMenu: '/easy/contract/contract',
                },
            }, {
                path: 'contract/bio/data/:tab/:refNo/:id',
                component: ContractBioData,
                name: 'ContractBioData',
                meta: {
                    firstMenu: '/easy/contract',
                    subMenu: '/easy/contract/contract',
                    position() {
                        let map = {
                            profile: 'Profile',
                            history: 'Employment History',
                            identity: 'Identity',
                            jobStatus: 'Job Status',
                        }
                        return map[this.params.tab]
                    },
                },
            }, {
                path: 'contract/detail/:tab/:refNo',
                component: ContractDetail,
                name: 'ContractDetail',
                meta: {
                    firstMenu: '/easy/contract',
                    subMenu: '/easy/contract/contract',
                    position() {
                        let map = {
                            timeLine: 'TimeLine',
                            jobOffer: 'Job Offer',
                            fee: 'Fee Breakdown and Payments',
                            application: 'Application Info',
                            pdf: 'All Files',
                            document: 'Documents Upload',
                        }
                        return map[this.params.tab]
                    },
                },
            }, {
                path: 'contract/template/edit/:id',
                component: ContractEditCustomTemplate,
                name: 'ContractEditCustomTemplate',
                meta: {
                    firstMenu: '/easy/contract',
                    subMenu: '/easy/contract/contract',
                },
            }, {
                path: 'contract/afterSales',
                component: ContractAfterSales,
                name: 'ContractAfterSales',
                meta: {
                    title: 'After Sales',
                },
            }, {
                path: 'contract/afterSales/detail/:id',
                component: ContractAfterSalesDetail,
                name: 'ContractAfterSalesDetail',
            }, {
                path: 'notFound',
                component: NotFound,
                name: 'NotFound',
            }, {
                path: 'insuranceOrder/list',
                component: InsuranceOrderList,
                name: 'InsuranceOrderList',
            }, {
                path: 'insuranceOrder/create',
                component: InsuranceOrderCreate,
                name: 'CreateInsuranceOrder',
            }, {
                path: 'insuranceOrder/detail/:id',
                component: InsuranceOrderDetail,
                name: 'InsuranceOrderDetail',
            }, {
                path: 'insuranceAgency/list',
                component: InsuranceAgencyList,
                name: 'InsuranceAgencyList',
            }, {
                path: 'insuranceSetting/:tab',
                component: insuranceSetting,
                name: 'insuranceSetting',
            }, {
                path: 'insuranceAgency/create',
                component: insuranceAgencyCreate,
                name: 'insuranceAgencyCreate',
            }, {
                path: 'insuranceAgency/detail/:id',
                component: insuranceAgencyDetail,
                name: 'insuranceAgencyDetail',
            }, {
                path: 'loanOrder/list',
                component: LoanOrderList,
                name: 'LoanOrderList',
            }, {
                path: 'loanOrder/detail/:tab/:id',
                component: LoanOrderDetail,
                name: 'LoanOrderDetail',
            }, {
                path: 'repaymentPlan/list',
                component: RepaymentPlanList,
                name: 'RepaymentPlanList',
            }, {
                path: 'embassy/PHEmbassy',
                component: PHEmbassy,
                name: 'PHEmbassy',
            }, {
                path: 'trainingOrder/list',
                component: TrainingOrderList,
                name: 'TrainingOrderList',
            }, {
                path: 'trainingOrder/detail/:tab/:id',
                component: TrainingOrderDetail,
                name: 'TrainingOrderDetail',
            }],
        }, {
            path: 'helper/pdf/:id',
            component: PreviewBioData,
            name: 'PreviewBioData',
            meta: {
                externalRecruiter: true,
            },
        },
        {
            path: 'contract/collect/jobOffer/:refNo',
            component: ContractCollectJobOffer,
            name: 'ContractCollectJobOffer',
        },
        {
            path: 'contract/collect/employerInfo/:refNo',
            component: ContractCollectEmployerInfo,
            name: 'ContractCollectEmployerInfo',
        },
        {
            path: 'contract/collect/sponsorJoint/:refNo',
            component: ContractCollectSponsorJointInfo,
            name: 'ContractCollectSponsorJointInfo',
        },
        {
            path: 'contract/collect/spouse/:refNo',
            component: ContractCollectSpouseInfo,
            name: 'ContractCollectSpouseInfo',
        },
        {
            path: 'contract/hk/collect/jobOffer/:refNo',
            component: HKContractCollectJobOffer,
            name: 'HKContractCollectJobOffer',
        },
        {
            path: 'contract/hk/collect/employerInfo/:refNo',
            component: HKContractCollectEmployerInfo,
            name: 'HKContractCollectEmployerInfo',
        },
        {
            path: 'contract/sales/hk/collect/jobOffer/:refNo',
            component: HKSalesContractCollectJobOffer,
            name: 'HKSalesContractCollectJobOffer',
        },
        {
            path: 'contract/sales/hk/collect/employerInfo/:refNo',
            component: HKSalesContractCollectEmployerInfo,
            name: 'HKSalesContractCollectEmployerInfo',
        },

        /** contract pdf start */
        {
            path: 'contract/pdf/preview/:refNo',
            component: ContractPreviewPdf,
            name: 'ContractPreviewPdf',
        },
        {
            path: 'insurance/pdf/preview/:id',
            component: InsurancePreviewPdf,
            name: 'InsurancePreviewPdf',
        },
        {
            path: 'contract/pdf/receipt/:refNo',
            component: ReceiptPDF,
            name: 'ReceiptPDF',
        },
        {
            path: 'contract/pdf/sign/:code',
            component: ContractSignPdf,
            name: 'ContractSignPdf',
            meta: {
                auth: false,
            },
        },
        {
            path: 'helper/signature/:linkCode',
            component: HelperSignature,
            name: 'HelperSignature',
            meta: {
                auth: false,
            },
        },
        {
            path: 'contract/share/helper/training/:refNo',
            component: ContractShareHelperTraining,
            name: 'ContractShareHelperTraining',
            meta: {
                auth: false,
            },
        },
        {
            path: 'insurance/pdf/sign/:code',
            component: InsuranceSignPdf,
            name: 'InsuranceSignPdf',
            meta: {
                auth: false,
            },
        },
        {
            path: 'supplier/link/sign/:code',
            component: SupplierLink,
            name: 'SupplierLink',
            meta: {
                auth: false,
            },
        },
        /** contract pdf end */
        {
            path: 'invoiceTemp',
            component: InvoiceTemp,
            name: 'InvoiceTemp',
        },
        {
            path: 'release/pdf/:code',
            component: ReleasePdf,
            name: 'ReleasePdf',
            meta: {
                auth: false,
            },
        },
        {
            path: 'chat',
            name: 'chat',
            component: Chat,
        }, {
            path: 'login',
            name: 'Login',
            component: Login,
            meta: {
                title: 'Login',
            },
        }, {
            path: 'registerForLogin',
            name: 'RegisterForLogin',
            component: RegisterForLogin,
        }, {
            path: 'CreateAccountNew',
            name: 'CreateAccountNew',
            component: CreateAccountNew,
        }, {
            path: '*',
            redirect: 'employer/list',
        }],
    }],
}]

const router = new VueRouter({
    mode: 'history',
    routes,
})
// 判断是否登录，没有登陆则跳转到登录页面
router.beforeEach((to: any, from, next) => {
    if (to.query.token) {
        Cookies.set('peanutManageAccessToken', to.query.token)
    }
    localStorage.setItem('currentRoutePath', to.fullPath)
    if (to.params.sourceData) {       // 设置source, 保存跳转之前页面关键数据
        to.params.source = from.name
        to.params.sourceData.source = from.name
        window.localStorage.setItem(to.name, JSON.stringify(to.params.sourceData))
    }
    if (to.meta.auth !== false && logic.getLogged()) {
        if (to.name === 'login') {
            next({name: from.name || 'EmployerList'})
        }
        if (JSON.parse(localStorage.getItem('userCompanyInfo') || '{}').roleNames === 'External Recruiter') {
            if (to.meta.externalRecruiter) {
                next()
            } else {
                next({name: 'HelperList'})
            }
        }
        if (to.name !== 'NoCompanyIndex' && !JSON.parse(localStorage.getItem('userCompanyInfo') || '{}').type) {
            next({name: 'NoCompanyIndex'})
        }
        if (to.meta.title) {
            document.title = to.meta.title
        } else {
            document.title = 'EASY'
        }
        next()
    } else {
        if (to.meta.title) {
            document.title = to.meta.title
        } else {
            document.title = 'EASY'
        }
        next()
    }
})

router.afterEach((to, from) => {
    judgeVersionRemind()
})

export default router
